import React from 'react';
import ResponsiveContext from '../ResponsiveContext';

export default function ResponsiveProvider(props) {
  const { children } = props;
  return <ResponsiveContext.Provider>{children}</ResponsiveContext.Provider>;
}
